export default function About(){
    return(<div id="aboutMe">
    <h2 className="sub-title first">About Me</h2>
    <div>
      <p className="about">Hello! My name is Freddy and I enjoy creating applications. My interest in programming started in my last year of high school. I didn't know what I wanted to do after high school but luckily, I was introduced to python in a after school program I would attend. I would then learn more languages like C and C++ and Javascript. From then on I started to program and learn new things almost everyday.</p>
      <p className="about">
        Fast-forward to today, I have been fortunate enough to be attending a University where I am pursuing a Bachelor degree in computer science. Some of the things I like to do when I am not programming are playing sports with friends such as soccer and basketball, playing video games, and much more. 
      </p>
      <div className="recentTools">
        <p>Here are a few technologies I've been working with recently:</p>
        <ul className='workTools'>
          <li>Javascript</li>
          <li>React</li>
          <li>Node.js</li>
          <li>Python</li>
          <li>mySQL</li>
          <li>Django</li>
        </ul>
      </div>

    </div>
  </div>)
}